import styled, { css } from "styled-components";
import { ContentBox } from "../../globalStyles/CardDetails";
import {
  PrimaryButton,
  SecretButton,
  AlternativeButton
} from "../../globalStyles/Containers";

export {
  CardClear,
  CardBox,
  HistoryCardBox,
  TitleBox,
  ContentBox
} from "../../globalStyles/CardDetails";

export {
  PrimaryButton,
  AlternativeButton,
  Paragraph,
  InlineParagraph,
  Centered,
  CenteredNoMargin,
  MoreInformationCentered,
  Toolbar,
  TextArea
} from "../../globalStyles/Containers";

export const SplitPanel = styled(ContentBox)`
  display: block;
  margin: 15px;
`;

export const Panel = styled.div`
  display: flex;
  margin: 0;
  justify-content: ${({ centered }) => (centered ? "center" : "end")};

  div {
    display: block;

    h3 {
      margin: 5px 0;
    }
  }
`;

export const Separator = styled.hr`
  margin: 10px;
  border: 1px solid ${({ theme }) => theme.backgroundColor};
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  img {
    width: 48%;
    height: 48%;
    max-width: 120px;
    max-height: 100px;
    margin: 2px;
  }
`;

export const DescriptionText = styled.p`
  text-align: left;
  margin: 10px;
`;

export const InformationText = styled.p`
  text-align: center;
  font-size: 14px;
  margin: 0 10px;
`;

export const ResumeText = styled(InformationText)`
  color: ${({ theme }) => theme.darkColor};
  margin: 0 15px;
`;

export const NotificationText = styled.p`
  text-align: left;
  margin: 0;
`;

export const DateTitle = styled.h2`
  color: ${({ theme }) => theme.primaryColor};
  margin-top: 5px;
  font-size: 16px;
`;

export const CardTitle = styled.h2`
  color: ${({ theme }) => theme.onBackgroundColor};
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
`;

export const NotificationTextStrong = styled(NotificationText)`
  font-weight: 900;
`;

export const DetailsPanel = styled(SplitPanel)`
  margin: 15px;
`;

export const DetailsPanelForButtons = styled(SplitPanel)`
  margin: 15px 0;
`;

export const MoreDetailsPanel = styled.div`
  margin-top: 20px;
`;

export const ImportantSubtitle = styled.h2`
  margin-bottom: 12px;
  font-size: 18px;
`;

export const VerticalToolbar = styled.div`
  margin: 15px 0 25px 0;
`;

export const verticalButton = css`
  font-size: 12px;
  padding: 14px;
  display: flex;
  margin-top: 20px;

  .right__icon {
    margin-left: auto;

    img {
      margin: 0;
    }
  }
`;

export const textButtonStyle = css`
  flex: auto;
  margin: auto;
  letter-spacing: 1px;
  text-decoration: none;
`;

export const VerticalPrimaryButton = styled(PrimaryButton)`
  ${verticalButton}
  margin-top: 20px;
  justify-content: center;

  a {
    ${textButtonStyle}
    color: ${({ theme }) => theme.onPrimaryColor};
  }
`;

export const VerticalTertiaryButton = styled(VerticalPrimaryButton)`
  margin: 0px;
  background-color: ${({ theme }) => theme.secondaryColor};
`;

export const VerticalSecretButton = styled(SecretButton)`
  ${verticalButton}
  font-weight: bold;

  div {
    flex-grow: 1;

    img {
      margin: auto;
      width: 13px;
      margin-right: 0;
    }
  }
`;

export const VerticalAlternativeButton = styled(AlternativeButton)`
  ${verticalButton}
  font-weight: bold;

  div {
    flex-grow: 1;
  }
`;

export const TextButton = styled.div`
  ${textButtonStyle}
  margin-right: 12px;
`;

export const VerticalPanel = styled.div`
  display: block;
  justify-content: center;
  text-align: center;

  h2 {
    margin: 0 0 15px 0;
  }

  svg {
    margin-top: 12px;
  }

  p {
    font-size: 14px;
  }
`;

export const ButtonWithTitle = styled.div`
  margin: 25px 0 30px 0;

  p {
    margin-bottom: 10px;
  }

  button {
    margin: 5px 0;
    font-weight: bold;
    font-size: 14px;
    padding: 14px;
  }
`;

export const CornerIcon = styled.div`
  text-decoration: none;

  svg {
    position: absolute;
    top: 20px;
  }
`;

export const RightCornerIcon = styled(CornerIcon)`
  svg {
    margin-left: 45px;
  }
`;

export const ButtonWithIcon = styled.div`
  display: contents;

  div {
    &:first-child {
      margin: 0 15px;
    }

    svg,
    img {
      margin: 0;
    }

    img {
      width: 30px;
    }
  }
`;
export const ButtonWithColumnIcon = styled(ButtonWithIcon)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ButtonLabel = styled.div`
  display: flex;
  width: 160px;
`;
